"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@material-ui/core/styles");

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _constants = require("../../constants");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TextCounter = _styledComponents.default.span`
	text-align: right;
	display: block;
`;
const Wrapper = _styledComponents.default.div`
	display: ${props => props.fullWidth ? 'block' : 'inline-block'};
`;
const CustomTextarea = (0, _styledComponents.default)(_InputBase.default)`
	label + & {
		margin-top: 4px;
	}
	& textarea {
		border: 1px solid ${_constants.colours.border};
		padding: 10px 12px;
		position: relative;
		transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
			box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
		border-radius: 4px;
		background-color: ${_constants.colours.white};
		width: ${props => props.fullWidth ? '100%' : null};
	}
	& textarea:focus {
		box-shadow: ${(0, _styles.fade)(_constants.colours.textareaActive, 0.25)} 0 0 0 0.2rem;
		border-color: ${_constants.colours.textareaActive};
	}
	& textarea[aria-invalid='true'] {
		box-shadow: ${(0, _styles.fade)(_constants.colours.red, 0.25)} 0 0 0 0.2rem;
		border-color: ${_constants.colours.red};
	}
`;

const Textarea = ({
  inputProps,
  label,
  onChange,
  value,
  fullWidth,
  maxLength,
  required,
  ...otherProps
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Wrapper, {
    fullWidth: fullWidth
  }, label && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(CustomTextarea, _extends({}, otherProps, {
    onChange: e => onChange(e.target.value, e),
    value: value,
    fullWidth: fullWidth,
    inputProps: {
      maxLength
    }
  })), maxLength && /*#__PURE__*/_react.default.createElement(TextCounter, null, value.length, " / ", maxLength)));
};

Textarea.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string,
  maxLength: _propTypes.default.number
};
Textarea.defaultProps = {
  value: '',
  maxLength: null
};
var _default = Textarea;
exports.default = _default;